<script setup>
import { computed } from 'vue';

const props = defineProps({
  size: {
    type: [Number, String],
    default: 24,
  },
});

const SIZE_MAP = {
  sm: 16,
  small: 16,
  md: 24,
  medium: 24,
  lg: 32,
  large: 32,
};

const normalizedSize = computed(() => {
  if (typeof props.size === 'string') {
    return SIZE_MAP[props.size.toLowerCase()] || 24;
  }

  return props.size;
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="normalizedSize"
    :height="normalizedSize"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="8"
    strokeLinecap="round"
    strokeLinejoin="round"
    class="animate-spin"
  >
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
</template>
